module.exports = __webpack_public_path__ + "img/pijltje-links-donker.e87704e85d25dbb6a7513b60137de54a.svg";